import PlayersTable from "./players-table";

export default PlayersTable;
